import axios from "axios";
import Event from "module/event/Event";

// Budget class  
class Budget extends Event{

    constructor(baseUrl, headers) {
        super(baseUrl, headers);
    }

}

export default Budget;